import React from 'react';
import _ from 'lodash';
import { Table, Dimmer, Loader } from 'semantic-ui-react';
import { TableFormDataRowProp } from '../../../../enum/apiResultProp/TableFormDataRowProp';
import { TableDataRowColor } from '../../../../enum/TableDataRowColor';
import AbstractTableFormCell from '../cell/AbstractTableFormCell'

export default ({
    tableDataRowProps, rowKey, onInputFieldChange, updateInputFieldErrorAction, onActionDownload,
    onButtonClickMutateScreenWithPostData, onFieldChangeMutateScreenWithPostData, onFieldChangeMutateComponentWithPostData,
    openModalForm
}) => {
    const cells = tableDataRowProps[TableFormDataRowProp.Cells];
    const color = tableDataRowProps[TableFormDataRowProp.Color];
    const hasSpinner = tableDataRowProps[TableFormDataRowProp.HasSpinner];
    const showSpinner = tableDataRowProps[TableFormDataRowProp.ShowSpinner];
    // const uniqueRowId = tableDataRowProps[TableFormDataRowProp.UniqueRowId];

    let warning = false;
    let positive = false;
    let negative = false;

    if (color === TableDataRowColor.Orange) {
        warning = true;
    } else if (color === TableDataRowColor.Red) {
        negative = true;
    } else if (color === TableDataRowColor.Green) {
        positive = true;
    }

    return (
        <Table.Row warning={warning} positive={positive} negative={negative} style={{ position: "relative"}}>
            {_.map(cells, (cellProps, cellKey) => {

                return (
                    <AbstractTableFormCell
                        key={cellKey}
                        rowKey={rowKey}
                        cellProps={cellProps}
                        onInputFieldChange={(props) => onInputFieldChange({ ...props, cellKey })}
                        updateInputFieldErrorAction={(props) => updateInputFieldErrorAction({ ...props, cellKey })}
                        onActionDownload={onActionDownload}
                        onButtonClickMutateScreenWithPostData={onButtonClickMutateScreenWithPostData}
                        onFieldChangeMutateScreenWithPostData={onFieldChangeMutateScreenWithPostData}
                        onFieldChangeMutateComponentWithPostData={onFieldChangeMutateComponentWithPostData}
                        openModalForm={openModalForm}
                        hasSpinner={hasSpinner}
                    />
                );
            })}

            {showSpinner && (
                <Table.Cell
                    colSpan={Object.keys(cells).length}
                    style={{ position: "absolute", top: 0, left: 0, right: 0, bottom: 0, padding: 0 }}
                >
                    <Dimmer active inverted>
                        <Loader inverted>Loading</Loader>
                    </Dimmer>
                </Table.Cell>
            )}
        </Table.Row>
    );
}